// extracted by mini-css-extract-plugin
export default {"separator":"cjTty"};